import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { AppTopbar } from './AppTopbar';
import { ImpersonationBanner } from './ImpersonationBanner';
import { SupportSessionBanner } from './SupportSessionBanner';

/**
 * The app shell: a tinted canvas, a nav rail of pills sitting directly on it,
 * and the page floating in one large-radius white panel.
 *
 * The chrome is deliberately inverted from the usual "white sidebar panel + white
 * page": tinting the canvas rather than a thin bar is what makes a global signal
 * — you are not in the live academic year — impossible to miss, because the tint
 * surrounds the work instead of capping it.
 *
 * Only the panel scrolls. The shell itself is pinned to the viewport so the
 * topbar's year control and the rail stay put on every page.
 */
export function Layout() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div
      data-testid="app-shell"
      className="flex h-screen flex-col bg-neutral-100 px-3 pb-3 text-neutral-900"
    >
      <AppTopbar onOpenNav={() => setNavOpen(true)} />
      <div className="flex min-h-0 flex-1">
        <AppSidebar navOpen={navOpen} onNavClose={() => setNavOpen(false)} />
        <main
          data-testid="app-panel"
          className="relative min-w-0 flex-1 overflow-y-auto rounded-[20px] bg-card shadow-[0_1px_2px_rgba(0,0,0,0.05),0_8px_24px_-18px_rgba(0,0,0,0.25)]"
        >
          {/* Above the impersonation banner, and outermost of the two: "whose
              account is this" has to be answered before "whose eyes am I looking
              through", and only one of the two can be true without the other. */}
          <SupportSessionBanner />
          <ImpersonationBanner />
          <Outlet />
        </main>
      </div>
    </div>
  );
}
